











































import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';

import SidebarNavItem from './SidebarNavItem.vue';
import StudioLogo from '@/web/components/navigation/StudioLogo.vue';

export default Vue.extend({
  name: 'StudioMobileMenu',
  components: {
    SidebarNavItem,
    StudioLogo,
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
    }),
    ...mapState('globals', ['isMainNavOpen']),
  },
  methods: {
    closeMainNav() {
      this.$store.dispatch('globals/openMainNav', false);
    },
  },
});
